import { useStore } from "zustand";

import FeatureFlagStoreContext, { TFeatureFlagStore } from "./store";

const isDev = process.env.NODE_ENV === "development";

const useFlag = (selector: (state: TFeatureFlagStore) => any = (s) => s) =>
  useStore(FeatureFlagStoreContext, selector);

// reactive selector
export const useFeatureFlag = (flag: string) => {
  const flags = useFlag((s) => s.flags);
  const isFeatureEnabled = flags.has(flag);

  if (isDev) {
    return true;
  }

  return isFeatureEnabled;
};

// non-reactive selector
export const getFlag = (flag: string) => {
  const flags = FeatureFlagStoreContext.getState().flags;
  return flags.has(flag);
};
